import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { GerenciarInstanciasWhatsApp } from './GerenciarInstanciasWhatsApp';

const Stack = createNativeStackNavigator();

export function WhatsAppStack() {
  return (
    <Stack.Navigator
      initialRouteName="GerenciarInstanciasWhatsApp"
      screenOptions={{
        headerShown: true,
        headerStyle: {
          backgroundColor: '#f5f5f5',
        },
        headerTintColor: '#000',
        headerTitleStyle: {
          fontWeight: 'bold',
        },
      }}
    >
      <Stack.Screen 
        name="GerenciarInstanciasWhatsApp" 
        component={GerenciarInstanciasWhatsApp} 
        options={{ title: 'Instâncias do WhatsApp' }} 
      />
    </Stack.Navigator>
  );
}
